import { render, staticRenderFns } from "./user_collect.vue?vue&type=template&id=fec79cba&scoped=true"
import script from "./user_collect.vue?vue&type=script&lang=js"
export * from "./user_collect.vue?vue&type=script&lang=js"
import style0 from "./user_collect.vue?vue&type=style&index=0&id=fec79cba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec79cba",
  null
  
)

export default component.exports